module.exports = __webpack_public_path__ + "img/money.3960bd7a.png";